import axios from 'axios'
export const GET_VIDEOS = 'nv/GET_VIDEOS'
export const GET_SETTINGS = 'nv/GET_SETTINGS'
export const GET_TRACKS = 'nv/GET_TRACKS'
export const GET_PHOTOS = 'nv/GET_PHOTOS'
export const TOGGLE_MESSAGE_SENT = 'nv/TOGGLE_MESSAGE_SENT'
const Api = 'https://api.newgroundworld.com'

const initialState = {
    videos: [],
    settings: {},
    tracks: [],
    photos: [],
    messageSent: false
}

export default ( state = initialState, action) => {
    switch(action.type) {
        case GET_VIDEOS:
            return {
                ...state,
                videos: action.payload
            }
        case GET_SETTINGS:
            return {
                ...state,
                settings: action.payload
            }
        case GET_TRACKS:
            return {
                ...state,
                tracks: action.payload
            }
        case GET_PHOTOS:
            return {
                ...state,
                photos: action.payload
            }
        case TOGGLE_MESSAGE_SENT:
            return {
                ...state,
                messageSent: !state.messageSent
            }
        default:
            return state
    }
}

const get_videos = videos => ({
    type: GET_VIDEOS,
    payload: videos
})

const get_settings = settings => ({
    type: GET_SETTINGS,
    payload: settings
})

const get_tracks = tracks => ({
    type: GET_TRACKS,
    payload: tracks
})

const get_photos = photos => ({
    type: GET_PHOTOS,
    payload: photos
})

const toggle_message_sent = () => ({
    type: TOGGLE_MESSAGE_SENT
})

export const getVideos = () => {
    return dispatch => {
        axios.get(`${Api}/videos`)
            .then((response) => {
                dispatch(get_videos(response.data))
            })
            .catch((error) => {
                console.log(error)
            })
    }
}

export const getSettings = () => {
    return dispatch => {
        axios.get(`${Api}/settings`)
            .then((response) => {
                dispatch(get_settings(response.data))
            })
            .catch((error) => {
                console.log(`Error => Fetching settings.`)
            })
    }
}

export const getTracks = () => {
    return dispatch => {
        axios.get(`${Api}/tracks`)
            .then((response) => {
                dispatch(get_tracks(response.data))
            })
            .catch((error) => {
                console.log(`Error => Fetching tracks.`)
            })
    }
}

export const getPhotos = () => {
    return dispatch => {
        axios.get(`${Api}/photos`)
            .then((response) => {
                dispatch(get_photos(response.data))
            })
            .catch((error) => {
                console.log(`Error => Fetching photos.`)
            })
    }
}

export const sendMessage = message => {
    return dispatch => {
        axios.post(`${Api}/message`, message)
            .then((response) => {
                dispatch(toggle_message_sent())
                return setTimeout(() => {
                    dispatch(toggle_message_sent())
                }, 3000)
            })
            .catch((error) => {
                // Handle error
            })
    }
}


// WEBPACK FOOTER //
// ./src/modules/nv.js